import { z } from "zod";

import { castToString } from "../../utils";

import {
  AnalyzeContext,
  BaseAnalyticsPayloadSchema,
  CastedTimes,
  PeriodTypeList,
  SubscriptionTypeSchema,
} from "./base";

// The request from BE > Analytics
export const SitewideAnalyticsPayloadSchema = BaseAnalyticsPayloadSchema.extend(
  {
    resourceType: z.literal("sitewide"),

    period: z.enum(PeriodTypeList),
    countryCodes: z.string().array(),
    subscriptionType: z.enum(SubscriptionTypeSchema).nullable(),
  }
);

export type SitewideAnalyticsPayloadType = z.infer<
  typeof SitewideAnalyticsPayloadSchema
>;

// The request from FE > Backend
export const AnalyzeSitewideRequestBodySchema =
  SitewideAnalyticsPayloadSchema.omit({
    shopifyDomain: true,
    latestRunTs: true,
    timezone: true,
  }).extend({
    id: z.string().uuid().optional(),
  });

export type AnalyzeSitewideRequestBodyType = z.infer<
  typeof AnalyzeSitewideRequestBodySchema
> &
  CastedTimes;

const AnalyzeSitewideContextSchema = AnalyzeContext;

export type AnalyzeSitewideContextType = z.infer<
  typeof AnalyzeSitewideContextSchema
>;
